<p>registration-conflict-modal works!</p>
